import { render, staticRenderFns } from "./DynamicLogo.vue?vue&type=template&id=c1df68ec&scoped=true&"
import script from "./DynamicLogo.vue?vue&type=script&lang=js&"
export * from "./DynamicLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1df68ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/unitech/keymetrics/pm2-io/pm2-io-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1df68ec')) {
      api.createRecord('c1df68ec', component.options)
    } else {
      api.reload('c1df68ec', component.options)
    }
    module.hot.accept("./DynamicLogo.vue?vue&type=template&id=c1df68ec&scoped=true&", function () {
      api.rerender('c1df68ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DynamicLogo.vue"
export default component.exports